import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { MdDateRange } from "react-icons/md";
import { BASEURL } from "../constants";

const CardSkeleton = () => (
  <div className="bg-white rounded-lg border-l-4 border-blue-500 shadow-md p-4 mb-4 w-full max-w-md">
    {/* badge */}
    <div className="mb-3">
      <div className="h-6 w-20 rounded-full bg-gray-200 animate-pulse" />
    </div>

    {/* title */}
    <div className="mb-3 space-y-2">
      <div className="h-4 w-3/4 rounded bg-gray-200 animate-pulse" />
      <div className="h-4 w-1/2 rounded bg-gray-200 animate-pulse" />
    </div>

    {/* date row */}
    <div className="flex items-center">
      <div className="w-7 h-7 bg-gray-200 rounded-full animate-pulse mr-2" />
      <div className="h-3 w-40 rounded bg-gray-200 animate-pulse" />
    </div>
  </div>
);

const Applications = () => {
  const studentId = localStorage.getItem("studentId");

  const [loading, setLoading] = useState(false);
  const [applicationData, setApplicationData] = useState([]);

  const getApplications = useCallback(async () => {
    if (!studentId) return;

    setLoading(true);
    try {
      const res = await axios.get(`${BASEURL}Student/Applications/${studentId}`);
      setApplicationData(res.data || []);
    } catch (err) {
      console.log("Getting applications error -> ", err);
    } finally {
      setLoading(false);
    }
  }, [studentId]);

  useEffect(() => {
    getApplications();
  }, [getApplications]);

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50">
        <div className="px-4 pb-6">
          <h1 className="text-gray-900 text-2xl font-bold text-center mb-6">
            Applications
          </h1>

          <div className="flex flex-col sm:flex-row gap-4 items-center px-4 pb-10">
            {[...Array(4)].map((_, i) => (
              <CardSkeleton key={i} />
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="px-4 pb-6">
        <h1 className="text-gray-900 text-2xl font-bold text-center mb-6">
          Applications
        </h1>

        {applicationData.length > 0 ? (
          <div className="flex flex-row gap-4 items-center px-4 pb-10">
            {applicationData.map((app) => (
              <div
                key={app.applicationId}
                className="bg-white rounded-lg border-l-4 border-blue-500 shadow-md p-4 mb-4 w-full max-w-md"
              >
                <div className="mb-3">
                  <span className="bg-emerald-50 text-emerald-600 text-xs font-medium px-2.5 py-1 rounded-full">
                    {(app?.courseCode || "").trim()}
                  </span>
                </div>

                <div className="text-gray-800 font-semibold mb-3">
                  {app?.courseName}
                </div>

                <div className="flex items-center text-gray-600 text-sm">
                  <div className="w-7 h-7 bg-gray-100 rounded-full flex items-center justify-center mr-2">
                    <MdDateRange size={14} />
                  </div>
                  {app?.applicationStartDate} – {app?.applicationEndDate}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-gray-500 text-center mt-16">
            No Application Found
          </div>
        )}
      </div>
    </div>
  );
};

export default Applications;
